var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViolationReviewSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758609905508,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4267,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M696.9 434c-42.6 0-82.8 10.2-118.5 28.3l-23.1-50.8c-17.6 11.9-37.2 20.9-58.3 26.4l27.5 60.6c-41.8 36.3-72 85.6-84.4 141.5H301.9l95-203.2c-20.9-6-40.4-15.4-57.7-27.7L231.3 640H64v320h612v-0.8c6.9 0.5 13.9 0.8 20.9 0.8 70.3 0 136.3-27.4 186-77 49.7-49.7 77.1-115.7 77.1-186 0-145-118-263-263.1-263zM128 896V704h306.1c1.8 67.6 28.9 131 76.9 179 4.5 4.5 9.2 8.9 14 13H128z m568.9 0C587.3 896 498 806.7 498 697s89.3-199 198.9-199C806.7 498 896 587.3 896 697s-89.3 199-199.1 199z",
    fill: "#727272",
    "p-id": 4268
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M639 254c0 65.5-33.1 123.3-83.6 157.4-17.6 11.9-37.2 20.9-58.3 26.4-15.4 4-31.5 6.1-48.1 6.1-18.1 0-35.6-2.5-52.1-7.2-20.9-6-40.4-15.4-57.7-27.7-48.5-34.3-80.2-91-80.2-155 0-105 85-190 190-190s190 85 190 190z",
    fill: "#5280C1",
    "p-id": 4269
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M704 704V576h-64v192h192v-64z",
    fill: "#669E8B",
    "p-id": 4270
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolationReviewSvg);
export default __webpack_public_path__ + "static/media/violationReviewSvg.8ca363733e56e69930788ffeeb3bba0f.svg";
export { ForwardRef as ReactComponent };